import {
  SubscriptionInvoiceItemType,
  UsePaginatedTableApiQuery,
} from '@portals/types';

import {
  SUBSCRIPTIONS_API_URL,
  subscriptionsQueryKeys,
} from './subscriptions.constants';
import {
  SubscriptionDetailsType,
  SubscriptionSummaryType,
} from './subscriptions.types';
import { useApiQuery } from '../../hooks';
import { QueryOptions } from '../../types';
import { usePaginatedTableApiQuery } from '../../utils';

export function useSubscriptions(
  tableState: UsePaginatedTableApiQuery<SubscriptionSummaryType>['tableState'],
  columns: UsePaginatedTableApiQuery<SubscriptionSummaryType>['columns'],
  baseUrl = SUBSCRIPTIONS_API_URL
) {
  return usePaginatedTableApiQuery<SubscriptionSummaryType>({
    baseUrl,
    queryKey: [...subscriptionsQueryKeys.base, baseUrl, tableState],
    tableState,
    columns,
    queryOptions: { staleTime: 0 },
  });
}

export function useSubscription(subscriptionId: string) {
  return useApiQuery<SubscriptionDetailsType>(
    `${SUBSCRIPTIONS_API_URL}/${subscriptionId}`,
    subscriptionsQueryKeys.detail(subscriptionId),
    {
      staleTime: 0,
    }
  );
}

export function useSubscriptionInvoiceItems(
  subscriptionId: string,
  queryOptions: QueryOptions<SubscriptionInvoiceItemType[]>
) {
  return useApiQuery<SubscriptionInvoiceItemType[]>(
    `${SUBSCRIPTIONS_API_URL}/${subscriptionId}/invoice_items`,
    subscriptionsQueryKeys.invoiceItems(subscriptionId),
    {
      staleTime: 0,
      ...queryOptions,
    }
  );
}
